import React, { useState } from 'react';
import http from '../../modules/api';
import PopupFrame from '../../modules/popup/PopupFrame';
import Button from "../../modules/common/Button";
import styles from './RoboImgSettingPopup.module.css';
import ai_badge from '../../../resources/img/ai_badge.svg';
import arrows_clockwise from '../../../resources/img/arrows_clockwise.svg';
import arrows_clockwise_white from '../../../resources/img/arrows_clockwise_white.svg';
import SaveDialogV2 from '../../modules/dialogs/SaveDialogV2';
import * as StringUtil from '../../modules/utils/StringUtil';
import TextInput from '../../modules/common/TextInput';

const stability_prompt = {
    52000 : "style_type_list",
    53000 : "composition_type_list",
    54000 : "ratio_list",
};
const prompt_max_length = 1000; // 프롬프트 최대 길이

/**
 * @param {*} className 클래스 명
 * @param {*} eventSeq event_seq
 * @param {*} imgPosition 이미지 위치 번호
 * @param {*} bannerCd 배너 번호
 * @param {*} bannerDirection 배너 유형 (03000 or 07000)
 * @function onClose 팝업 닫기
 * @function sendRoboImg 로보이미지를 받는 함수
 */
class RoboInpatingSettingPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            prompt : "",
            before_prompt_seq : "",

            style_type_list : [],
            composition_type_list : [],
            ratio_list : [],

            defaultImageLink : this.props.defaultImageLink ? this.props.defaultImageLink : "",
            file_name : this.props.defaultImageLink ? this.props.defaultImageLink.split('/').pop().split('?')[0].split('#')[0] : "",

            style_type_cd : "",
            composition_type_cd : "",
            ratio : "",
            width : "",
            height : "",

            robo_img : "",

            show_input_prompt_popup : true, // 프롬프트를 입력하는 팝업 표시 상태
            show_loading_dialog : false, // 로딩 다이얼로그 표시 상태
            show_robo_img_popup : false, // 생성된 로보 이미지를 보는 팝업 표시 상태

            ratio : "",
        }
        this.fileInputRef = React.createRef();
    }

    componentDidMount(){
        console.log("defaultImageLink", this.props.defaultImageLink);
    }


    onChangePrompt1 = (e) => {
        this.setState({prompt1 : e.target.value});
    }
    onChangePrompt2 = (e) => {
        this.setState({prompt2 : e.target.value});
    }

    /** 이미지 만들기 */
    // getRoboImage = () => {
    //     const prompt = this.state.prompt.replaceAll(/[\[\]:]/g, ""); // 프롬프트의 대괄호와 콜론을 빈문자로 바꿔서 전달
    //     this.setState({prompt : prompt});
        
    //     this.setState({
    //         show_input_prompt_popup : false,
    //         show_robo_img_popup : false,
    //         show_loading_dialog : true,
    //     });
    //     const body = {
    //         prompt : prompt,
    //         style_type_cd : this.state.style_type_cd,
    //         composition_type_cd : this.state.composition_type_cd,
    //         width : this.state.width,
    //         height : this.state.height,
    //     };
	// 	http.post("/rest/shop/generate",body, {headers: {'Content-Type': 'application/json'}})
	// 	.then(res => {
    //         if(res.data.code == "200" && res.data.result.resCode != "500"){
    //             this.setState({
    //                 robo_img:res.data.result.url[0],
    //                 show_loading_dialog : false,
    //                 show_robo_img_popup : true,
    //             });
    //             this.saveRoboImageHist(res.data.final_prompts, res.data.result.url);
    //         } else{
    //             this.saveRoboImageHist(res.data.final_prompts, res.data.result.url);
    //             alert("이미지를 생성할 수 없어요.\n다시 시도해도 안되면 다른 아이디어를 입력해 주세요.");
    //             this.setState({
    //                 show_loading_dialog : false,
    //                 show_input_prompt_popup : true,
    //             });
    //         }
    //     })
    //     .catch(error=> {
    //         alert("이미지를 생성할 수 없어요.\n다시 시도해도 안되면 다른 아이디어를 입력해 주세요.");
    //         this.setState({
    //             show_loading_dialog : false,
    //             show_input_prompt_popup : true,
    //         });
    //     });
    // }

    handleSubmit = async () => {
        if (!this.state.file && !this.state.defaultImageLink) return alert("이미지를 업로드 해주세요");
    
        let prompt = "";
        if (this.state.prompt1) {
            prompt += '제공된 이미지는 "' + this.state.prompt1 + '" 이야.';
        }
        if (this.state.prompt2) {
            prompt += ' 내가 생성하고 싶은 배경은 "'+ this.state.prompt2 + '" 이야.';
        }

        const formData = new FormData();
        formData.append("prompt", prompt);
        formData.append("image", this.state.file);
        formData.append("defaultImageLink", this.state.defaultImageLink);
        if (this.props.ratio) {
            formData.append("ratio", this.props.ratio);
        }
    
        this.setState({
            // show_input_prompt_popup : false,
            show_robo_img_popup : false,
            show_loading_dialog : true,
        });
        try {
            const res = await http.post(
                // "/rest/shop/generate", 
                "/rest/common/genai/inpaint", 
                formData, 
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );
          
            this.setState({
                // robo_img:res.data.generated_image_url,
                robo_img:res.data.imageUrl,
                // show_input_prompt_popup : false,
                show_loading_dialog : false,
                show_robo_img_popup : true,
            });
        } catch (err) {
            console.error("오류 발생: ", err.message);
            alert("이미지를 생성할 수 없어요.\n다시 시도해도 안되면 다른 아이디어를 입력해 주세요.");
        } finally {
            this.setState({
                show_loading_dialog : false,
            });;
        }
    };

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({ 
                file: file,
                file_name: file.name ,
                defaultImageLink : "",
            });
        }
    };

    render () {
		const {className, onClose, sendRoboImg} = this.props;
        return (
            <>
                <div className={["robo_img_setting_popup",className].join(' ')}>
                    {this.state.show_input_prompt_popup &&
                        // <PopupFrame
                        //     maxWidth={"460px"}
                        //     title={"AI로 사진 배경 새로 만들기"}
                        //     titleIcon={ai_badge}
                        //     content={"원하는 이미지를 AI로 만들어낼 수 있어요.<br/>아이디어만 입력해서 AI로 간단하게 완성해 보세요!"}
                        //     onClose={onClose}
                        // >
                            <div className={styles.robo_img_popup}>
                                <div style={{
                                    fontFamily: 'Noto Sans KR',
                                    fontWeight: 700,
                                    fontSize: '14px',
                                    lineHeight: '150%',
                                    marginBottom:"10px",
                                }}>사진 속 변경없이 유지하고 싶은 상품은 무엇인가요?</div>
                                <div className={styles.input_prompt} style={{height:"50px", paddingTop: "0px"}}>
                                    <textarea
                                        placeholder={""}
                                        value={this.state.prompt1}
                                        onChange={e => this.onChangePrompt1(e)}
                                        maxLength={prompt_max_length}
                                        style={{border:"0px", height:"100%", overflow: "hidden", padding: "14px 16px"}}
                                    ></textarea>
                                    </div>
                                <div style={{
                                    marginTop:"10px",
                                    fontFamily: 'Noto Sans KR',
                                    fontWeight: 700,
                                    fontSize: '14px',
                                    lineHeight: '150%',
                                    marginBottom:"10px",
                                }}> 원하는 배경사진이 있다면 AI에게 자세히 설명해주세요</div>
                                <div className={styles.input_prompt} style={{height:"50px", paddingTop: "0px"}}>
                                    <textarea
                                        height={"50px"}
                                        placeholder={""}
                                        value={this.state.prompt2}
                                        onChange={e => this.onChangePrompt2(e)}
                                        maxLength={prompt_max_length}
                                        style={{border:"0px", height:"100%", overflow: "hidden", padding: "14px 16px"}}
                                    ></textarea>
                                </div>
                                <button
                                    style={{
                                        marginTop:"20px",
                                        borderRadius:"20px",
                                        border: '1px solid #0000001F',
                                        background: '#F0F0F0',
                                        borderRadius: '10px',
                                        borderWidth: '1px',
                                        width: "100%",
                                        height: "50px",
                                        display: "flex",
                                        justifyContent: "center",
                                        flexWrap: "nowrap",
                                        gap: "10px",
                                        alignItems: "center",
                                        fontSize: "14px",
                                        cursor: "pointer",
                                        marginBottom:"5px",
                                    }}
                                    onClick={ () => {this.fileInputRef.current.click()}}
                                >
                                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.5268 10V3C13.5268 2.73478 13.415 2.48043 13.216 2.29289C13.0169 2.10536 12.747 2 12.4656 2H1.85412C1.57268 2 1.30278 2.10536 1.10377 2.29289C0.904768 2.48043 0.792969 2.73478 0.792969 3V13C0.792969 13.2652 0.904768 13.5196 1.10377 13.7071C1.30278 13.8946 1.57268 14 1.85412 14H12.4656C12.747 14 13.0169 13.8946 13.216 13.7071C13.415 13.5196 13.5268 13.2652 13.5268 13V10ZM12.4656 3V8.79375L10.5622 7C10.3624 6.8145 10.0932 6.71051 9.81273 6.71051C9.53227 6.71051 9.26307 6.8145 9.0633 7L6.09871 9.79375L4.72585 8.5C4.52608 8.3145 4.25688 8.21051 3.97642 8.21051C3.69596 8.21051 3.42675 8.3145 3.22698 8.5L1.85412 9.79375V3H12.4656ZM12.4656 13H1.85412V11.2063L3.97642 9.20625L5.34928 10.5C5.54905 10.6855 5.81825 10.7895 6.09871 10.7895C6.37917 10.7895 6.64838 10.6855 6.84815 10.5L9.81273 7.70625L12.4656 10.2063V13ZM4.73912 6.28125C4.66498 6.21163 4.60627 6.12881 4.56642 6.0376C4.52657 5.9464 4.50637 5.84863 4.50699 5.75C4.50699 5.55109 4.59084 5.36032 4.74009 5.21967C4.88935 5.07902 5.09178 5 5.30285 5C5.51393 5 5.71636 5.07902 5.86561 5.21967C6.01486 5.36032 6.09871 5.55109 6.09871 5.75C6.09871 5.94891 6.01486 6.13968 5.86561 6.28033C5.71636 6.42098 5.51393 6.5 5.30285 6.5C5.092 6.49848 4.88997 6.42008 4.73912 6.28125Z" fill="#333333"/>
                                    <rect x="11.5664" width="0.979522" height="5" rx="0.489761" fill="#333333"/>
                                    <rect x="9.60742" y="3" width="1" height="4.89761" rx="0.5" transform="rotate(-90 9.60742 3)" fill="#333333"/>
                                    </svg>
                                    <span>배경을 변경할 이미지 업로드</span>
                                </button>
                                <input
                                    type="file"
                                    ref={this.fileInputRef}
                                    onChange={this.handleFileChange}
                                    style={{ display: 'none'}}
                                    accept="image/png, image/jpeg, image/webp"
                                />
                                <TextInput
                                    type="text" 
                                    placeholder="업로드 된 파일명"
                                    value={this.state.file_name}
                                    disabled={true}
                                    width = "100%"
                                    height = "40px"
                                />

                                <button
                                    style={{
                                        marginTop:"20px",
                                        borderRadius:"20px",
                                        border: '1px solid #0000001F',
                                        background: '#00e2e6',
                                        borderRadius: '10px',
                                        borderWidth: '1px',
                                        width: "100%",
                                        height: "50px",
                                        display: "flex",
                                        justifyContent: "center",
                                        flexWrap: "nowrap",
                                        gap: "10px",
                                        alignItems: "center",
                                        fontSize: "14px",
                                        cursor: "pointer",
                                        marginTop:"20px",
                                    }}
                                    onClick={ () => {this.handleSubmit()}}
                                >
                                    {/* <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.5268 10V3C13.5268 2.73478 13.415 2.48043 13.216 2.29289C13.0169 2.10536 12.747 2 12.4656 2H1.85412C1.57268 2 1.30278 2.10536 1.10377 2.29289C0.904768 2.48043 0.792969 2.73478 0.792969 3V13C0.792969 13.2652 0.904768 13.5196 1.10377 13.7071C1.30278 13.8946 1.57268 14 1.85412 14H12.4656C12.747 14 13.0169 13.8946 13.216 13.7071C13.415 13.5196 13.5268 13.2652 13.5268 13V10ZM12.4656 3V8.79375L10.5622 7C10.3624 6.8145 10.0932 6.71051 9.81273 6.71051C9.53227 6.71051 9.26307 6.8145 9.0633 7L6.09871 9.79375L4.72585 8.5C4.52608 8.3145 4.25688 8.21051 3.97642 8.21051C3.69596 8.21051 3.42675 8.3145 3.22698 8.5L1.85412 9.79375V3H12.4656ZM12.4656 13H1.85412V11.2063L3.97642 9.20625L5.34928 10.5C5.54905 10.6855 5.81825 10.7895 6.09871 10.7895C6.37917 10.7895 6.64838 10.6855 6.84815 10.5L9.81273 7.70625L12.4656 10.2063V13ZM4.73912 6.28125C4.66498 6.21163 4.60627 6.12881 4.56642 6.0376C4.52657 5.9464 4.50637 5.84863 4.50699 5.75C4.50699 5.55109 4.59084 5.36032 4.74009 5.21967C4.88935 5.07902 5.09178 5 5.30285 5C5.51393 5 5.71636 5.07902 5.86561 5.21967C6.01486 5.36032 6.09871 5.55109 6.09871 5.75C6.09871 5.94891 6.01486 6.13968 5.86561 6.28033C5.71636 6.42098 5.51393 6.5 5.30285 6.5C5.092 6.49848 4.88997 6.42008 4.73912 6.28125Z" fill="#333333"/>
                                    <rect x="11.5664" width="0.979522" height="5" rx="0.489761" fill="#333333"/>
                                    <rect x="9.60742" y="3" width="1" height="4.89761" rx="0.5" transform="rotate(-90 9.60742 3)" fill="#333333"/>
                                    </svg> */}
                                    <span>이미지 만들기</span>
                                </button>
                            </div>
                        // </PopupFrame>
                    }

                    {this.state.show_loading_dialog &&
                        <SaveDialogV2
                            content={"인공지능이 이미지를 만들고 있어요.<br/>조금만 기다려 주세요 :)"}
                            button_list={[{
                                title: "확인",
                                type: "1",
                                display_yn:"N",
                            }]}
                        />
                    }
                    
                    {this.state.show_robo_img_popup &&
                        <PopupFrame
                            maxWidth={"600px"}
                            onClose={onClose}
                            headerMarginBottom={"0px"}
                            backAction={() => {
                                this.setState({
                                    show_input_prompt_popup : true,
                                    show_robo_img_popup : false,
                                });
                            }}
                        >
                            <div className={styles.img_popup_title}>
                                AI 이미지가 만들어졌어요.<br/>
                                나만의 상품 이미지로 배너 디자인에 활용해 보세요.
                            </div>
                            <img className={styles.robo_img} src={this.state.robo_img}/>
                            <div className={[styles.robo_img_button_area, "style_guide_v2"].join(' ')}>
                                <button className={"hover_white"} onClick={this.handleSubmit}>다른 이미지 보기</button>
                                <button className={"hover_mint"} onClick={() => sendRoboImg(this.state.robo_img)}>이미지 적용하기</button>
                            </div>
                        </PopupFrame>
                    }
                </div>
            </>
        )
    };
}

export default RoboInpatingSettingPopup;